import type { WorkerSearchRow } from '@/routes/Agency/TestAnnouncement/lib';
import { axiosRubyClient as api } from '@/util/axios/axiosClient';

interface WorkersIndexResponse {
  success: boolean;
  data: Array<{
    id: number;
    active: boolean;
    avatar_url?: string | null;
    user?: {
      id: number;
      first_name?: string | null;
      last_name?: string | null;
      email?: string | null;
    } | null;
  }>;
}

interface DirectAnnouncementResponse {
  success: boolean;
  data?: { id: number };
  errors?: string[];
}

interface SendPayload {
  title: string;
  message: string;
  expireAt: string;
  userIds: number[];
}

export const testAnnouncementAPI = {
  // GET /api/admin/workers?search= — lightweight worker rows for the picker.
  searchWorkers: async (search: string): Promise<WorkerSearchRow[]> => {
    const res = await api.get<WorkersIndexResponse>('/api/admin/workers', {
      params: { search, per_page: 20 },
    });
    return (res.data.data ?? []).map((r) => ({
      id: r.id,
      active: r.active,
      avatar_url: r.avatar_url ?? null,
      user: r.user
        ? {
            id: r.user.id,
            first_name: r.user.first_name ?? null,
            last_name: r.user.last_name ?? null,
            email: r.user.email ?? null,
          }
        : null,
    }));
  },

  // POST /api/admin/announcements/direct — real isolated send (ChatGroup
  // record + PubNub fan-out to exactly these User ids).
  sendDirect: async (
    payload: SendPayload,
  ): Promise<{ success: boolean; id: number | null }> => {
    const res = await api.post<DirectAnnouncementResponse>(
      '/api/admin/announcements/direct',
      payload,
    );
    return { success: !!res.data.success, id: res.data.data?.id ?? null };
  },
};
